import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Button,
  Chip,
  IconButton,
  Collapse,
} from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useNavigate } from "react-router-dom";
import { getToken, clearSession } from "../../api/session";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const token = getToken();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const handleLogout = () => {
    clearSession();
    navigate("/build/login");
  };


  return (
    <AppBar
      position="static"
      color="inherit"
      elevation={0}
      sx={{ border: "none", background: "transparent" }}
    >
      {isDesktop ? (
        /* Desktop: Old UI design (above 1024px) */
        <Box className="top-banner">
          <Box className="logo-card" onClick={() => navigate("/")}>
            <img
              src="/v_two_black.png" // Replace with your logo path
              alt="OnePass Logo"
              className="logo-image"
            />

            <Box className="logo-content hidden">
              <Typography
                variant="h4"
                component="h1"
                fontWeight={700}
                color="white"
              >
                OnePass
              </Typography>

              <Typography
                variant="body2"
                fontWeight={600}
                fontSize={12}
                color="#6b8fdb"
                textTransform="uppercase"
              >
                Powered by OnePassBlueprint.com
              </Typography>
            </Box>
          </Box>
          <Container>
            <Box className="top-banner-content">
              <Typography
                component="span"
                className="banner-title"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "white",
                }}
              >
                <span className="banner-inline-text">
                  <svg
                    className="banner-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 511.987 511"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        fill="#ffc107"
                        d="M510.652 185.902a27.158 27.158 0 0 0-23.425-18.71l-147.774-13.419-58.433-136.77C276.71 6.98 266.898.494 255.996.494s-20.715 6.487-25.023 16.534l-58.434 136.746-147.797 13.418A27.208 27.208 0 0 0 1.34 185.902c-3.371 10.368-.258 21.739 7.957 28.907l111.7 97.96-32.938 145.09c-2.41 10.668 1.73 21.696 10.582 28.094 4.757 3.438 10.324 5.188 15.937 5.188 4.84 0 9.64-1.305 13.95-3.883l127.468-76.184 127.422 76.184c9.324 5.61 21.078 5.097 29.91-1.305a27.223 27.223 0 0 0 10.582-28.094l-32.937-145.09 111.699-97.94a27.224 27.224 0 0 0 7.98-28.927zm0 0"
                        opacity="1"
                        data-original="#ffc107"
                      ></path>
                    </g>
                  </svg>
                  <span>
                    <strong>Free to try for 30 days.</strong> No registration
                    required.
                  </span>
                </span>
              </Typography>

              <Typography component="span" className="banner-divider">
                |
              </Typography>

              <Typography className="banner-description">
                OnePass is launching with free access to create validated
                blueprints for a variety of project types. Prepare, lock, and send
                to third-party tools.
              </Typography>
            </Box>

            <Box className="banner-badges">
              <Chip
                label="No registration required"
                className="banner-chip"
                size="small"
              />
              <Chip
                label="Free pilot access"
                className="banner-chip"
                size="small"
              />
              <Chip
                label="Create multiple blueprint types"
                className="banner-chip"
                size="small"
              />
              <Chip
                label="Export to coding tools"
                className="banner-chip"
                size="small"
              />
              <Chip
                label="Privacy-first experience"
                className="banner-chip"
                size="small"
              />
            </Box>
          </Container>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            {token ? (
              <>
                {/* The whole signed-in product, in four steps:
                    Create New Blueprint -> My Projects -> Billing -> Account. */}
                <Button
                  component={Link}
                  to="/build"
                  variant="contained"
                  color="primary"
                  sx={{
                    background: "linear-gradient(93deg,#001645 0%,#0055FF 100%)",
                    boxShadow: "0 8px 24px rgba(0,85,255,.50)",
                    border: "1px solid #0238a5",
                    textWrap: "nowrap",
                  }}
                >
                  Create New Blueprint
                </Button>
                <Button component={Link} to="/build/dashboard" variant="outlined" color="primary"
                  sx={{ bgcolor: "white", textWrap: "nowrap", "&:hover": { bgcolor: "#f0f0f0" } }}>
                  My Projects
                </Button>
                <Button component={Link} to="/build/billing" variant="outlined" color="primary"
                  sx={{ bgcolor: "white", "&:hover": { bgcolor: "#f0f0f0" } }}>
                  Billing
                </Button>
                <Button component={Link} to="/build/account" variant="outlined" color="primary"
                  sx={{ bgcolor: "white", "&:hover": { bgcolor: "#f0f0f0" } }}>
                  Account
                </Button>
                <Button variant="outlined" color="primary" onClick={handleLogout} sx={{ bgcolor: 'white', '&:hover': { bgcolor: '#f0f0f0' } }}>
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  component={Link}
                  to="/build/login"
                  variant="outlined"
                  color="white"
                  sx={{ height: "fit-content", textWrap: "nowrap" }}
                >
                  Sign In
                </Button>
                <Button
                  component={Link}
                  to="/build/register"
                  variant="contained"
                  color="primary"
                  sx={{
                    height: "fit-content",
                    background: "linear-gradient(93deg,#001645 0%,#0055FF 100%)",
                    boxShadow: "0 8px 24px rgba(0,85,255,.50)",
                    border: "1px solid #0238a5",
                    textWrap: "nowrap"
                  }}
                >
                  Sign Up
                </Button>
              </>
            )}
          </Box>
        </Box>
      ) : (
        /* Mobile: New responsive layout (below 1024px) */
        <>
          {/* Announcement Bar */}
          <Box className="announcement-bar">
            <Container maxWidth="xl" className="announcement-container">
              <Typography variant="body2" className="announcement-text">
                <span className="banner-inline-text">
                  <svg
                    className="banner-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 511.987 511"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        fill="#ffc107"
                        d="M510.652 185.902a27.158 27.158 0 0 0-23.425-18.71l-147.774-13.419-58.433-136.77C276.71 6.98 266.898.494 255.996.494s-20.715 6.487-25.023 16.534l-58.434 136.746-147.797 13.418A27.208 27.208 0 0 0 1.34 185.902c-3.371 10.368-.258 21.739 7.957 28.907l111.7 97.96-32.938 145.09c-2.41 10.668 1.73 21.696 10.582 28.094 4.757 3.438 10.324 5.188 15.937 5.188 4.84 0 9.64-1.305 13.95-3.883l127.468-76.184 127.422 76.184c9.324 5.61 21.078 5.097 29.91-1.305a27.223 27.223 0 0 0 10.582-28.094l-32.937-145.09 111.699-97.94a27.224 27.224 0 0 0 7.98-28.927zm0 0"
                        opacity="1"
                        data-original="#ffc107"
                      ></path>
                    </g>
                  </svg>
                  <span>
                    <strong>Free to try for 30 days.</strong> No registration required. &bull; OnePass is launching with free access to create validated blueprints for a variety of project types. Prepare, lock, and send to third-party tools.
                  </span>
                </span>
              </Typography>
            </Container>
          </Box>

          {/* Main Navbar */}
          <Box className="main-navbar">
            <Box className="navbar-logo-section" onClick={() => navigate("/")}>
              <img
                src="/v_two_black.png" // Replace with your logo path
                alt="OnePass Logo"
                className="logo-image"
              />

              <Box className="logo-content hidden">
                <Typography
                  variant="h4"
                  component="h1"
                  fontWeight={700}
                  color="white"
                >
                  OnePass
                </Typography>

                <Typography
                  variant="body2"
                  fontWeight={600}
                  fontSize={12}
                  color="#6b8fdb"
                  textTransform="uppercase"
                >
                  Powered by OnePassBlueprint.com
                </Typography>
              </Box>
            </Box>

            <IconButton
              onClick={() => setMenuOpen(!menuOpen)}
              sx={{ color: "white" }}
              aria-label="toggle menu"
            >
              {menuOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>

            <Collapse in={menuOpen} className="navbar-mobile-collapse">
              <Box className="navbar-mobile-menu">
                <Typography className="mobile-menu-title">HIGHLIGHTS</Typography>
                <Box className="mobile-badges-grid">
                  <Chip
                    label="No registration required"
                    className="banner-chip"
                    size="small"
                  />
                  <Chip
                    label="Free pilot access"
                    className="banner-chip"
                    size="small"
                  />
                  <Chip
                    label="Create multiple blueprint types"
                    className="banner-chip"
                    size="small"
                  />
                  <Chip
                    label="Export to coding tools"
                    className="banner-chip"
                    size="small"
                  />
                  <Chip
                    label="Privacy-first experience"
                    className="banner-chip"
                    size="small"
                  />
                </Box>

                <Box className="mobile-menu-divider" />

                <Box className="mobile-auth-section">
                  {token ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, width: "100%" }}>
                      {/* Same four steps as the desktop nav, stacked. */}
                      <Button
                        component={Link}
                        to="/build"
                        onClick={() => setMenuOpen(false)}
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          background: "linear-gradient(93deg,#001645 0%,#0055FF 100%)",
                          boxShadow: "0 8px 24px rgba(0,85,255,.50)",
                          border: "1px solid #0238a5",
                        }}
                      >
                        Create New Blueprint
                      </Button>
                      <Button
                        component={Link}
                        to="/build/dashboard"
                        onClick={() => setMenuOpen(false)}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{ color: "#0d47a1" }}
                      >
                        My Projects
                      </Button>
                      <Button
                        component={Link}
                        to="/build/billing"
                        onClick={() => setMenuOpen(false)}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{ color: "#0d47a1" }}
                      >
                        Billing
                      </Button>
                      <Button
                        component={Link}
                        to="/build/account"
                        onClick={() => setMenuOpen(false)}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{ color: "#0d47a1" }}
                      >
                        Account
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          handleLogout();
                          setMenuOpen(false);
                        }}
                        fullWidth
                        className="logout-btn"
                        sx={{ color: "#0d47a1", borderColor: "rgba(255,255,255,0.3)" }}
                      >
                        Logout
                      </Button>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 1.5, }}>
                      <Button
                        component={Link}
                        to="/build/login"
                        onClick={() => setMenuOpen(false)}
                        variant="outlined"
                        color="white"
                        fullWidth
                        className="signin-btn"
                        sx={{
                          textWrap: "nowrap"
                        }}
                      >
                        Sign In
                      </Button>
                      <Button
                        component={Link}
                        to="/build/register"
                        onClick={() => setMenuOpen(false)}
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          background: "linear-gradient(93deg,#001645 0%,#0055FF 100%)",
                          boxShadow: "0 8px 24px rgba(0,85,255,.50)",
                          border: "1px solid #0238a5",
                          textWrap: "nowrap"
                        }}
                        className="signup-btn"
                      >
                        Sign Up
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Collapse>
          </Box>
        </>
      )}
    </AppBar>
  );
}

export default Header;
